/* eslint-disable react/prop-types */
import React, { Component } from 'react';

import { Link } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';

import classes from './ConfigurationScreenContent.css';
import Aux from '../../../hoc/Aux';
import lang from '../../../lang.json';

class ConfigurationScreenContentHome extends Component {
  render() {
    return (
      <Aux>
        <div className="container-fluid">
          <div className="row">
            <div className="col" />
            <div className={`col-8 ${classes.TitleCard}`}> 
              <div className="row">
                <div className="col-8">
                  <br />
                  <h3> 
                    {lang[this.props.language].confscreen_home_title_1of2}
                    <br />
                    {lang[this.props.language].confscreen_home_title_2of2}
                  </h3>
                  <br />
                  <br />
                  <p className={classes.DescriptionCard}>
                    {lang[this.props.language].confscreen_home_description}
                  </p>
                </div>
                <div className="col-4 align-self-center">
                  <img src={require('../../../assets/img/settings.png')} alt="img-psw" className={classes.ImgHome} />
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col" />
            <div className="col-8">
              <h3>{lang[this.props.language].confscreen_home_menu_tool}</h3>
              <div className="row">          
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`}>
                  <Link to="/config/account" className={classes.NoDe}> 
                    <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-user.svg')} alt="img" />
                    <p className={classes.DescriptionButton}>
                      <br />
                      {lang[this.props.language].confscreen_home_menu_tool_btn_edit_account}
                    </p>
                  </Link>
                </div>          
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`}>
                  <Link to="/config/playlist" className={classes.NoDe}> 
                    <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-playlist.svg')} alt="img" />
                    <p className={classes.DescriptionButton}>
                      <br />
                      {lang[this.props.language].confscreen_home_menu_tool_btn_edit_playlist}
                    </p>
                  </Link>
                </div> 
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`}>
                  <Link to="/config/genres" className={classes.NoDe}> 
                    <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-genres.svg')} alt="img" />
                    <p className={classes.DescriptionButton}>
                      <br />
                      {lang[this.props.language].confscreen_home_menu_tool_btn_edit_genres}
                    </p>
                  </Link>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} data-place="top" data-tip={lang[this.props.language].available_soon}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-volume.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_home_menu_tool_btn_edit_volume}
                  </p>
                </div>
                <div className="col" />
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col" />
            <div className="col-8">
              <h3>{lang[this.props.language].confscreen_home_menu_tool_ban}</h3>
              <div className="row">
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`}>
                  <Link to="/config/filters" className={classes.NoDe}> 
                    <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-filter.svg')} alt="img" />
                    <p className={classes.DescriptionButton}>
                      <br />
                      {lang[this.props.language].confscreen_home_menu_tool_btn_edit_filters}
                    </p>
                  </Link>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} data-place="top" data-tip={lang[this.props.language].available_soon}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-padlock.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_home_menu_tool_btn_edit_ban}
                  </p>
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col" />
            <div className="col-8">
              <h3>{lang[this.props.language].confscreen_home_menu_tool_ads}</h3>
              <div className="row">
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} data-place="top" data-tip={lang[this.props.language].available_soon}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-ads.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_home_menu_tool_btn_edit_ads}
                  </p>
                </div>
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} data-place="top" data-tip={lang[this.props.language].available_soon}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-calendar.png')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_home_menu_tool_btn_edit_special_day}
                  </p>
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
          <br />
          <br />
          <div className="row">
            <div className="col" />
            <div className="col-8">
              <h3>{lang[this.props.language].confscreen_home_menu_tool_analytics}</h3>
              <div className="row">
                <div className={`col-1 ${classes.LinkCard} ${classes.TxtCenter}`} data-place="top" data-tip={lang[this.props.language].available_soon}>
                  <img className={classes.ImgButtonLink} src={require('../../../assets/svg/ic-analisi.svg')} alt="img" />
                  <p className={classes.DescriptionButton}>
                    <br />
                    {lang[this.props.language].confscreen_home_menu_tool_btn_edit_analytics}
                  </p>
                </div>
              </div>
            </div>
            <div className="col" />
          </div>
        </div>
        <ReactTooltip />
      </Aux>
    );
  }
} 

export default ConfigurationScreenContentHome;
